import { css } from '@/styled-system/css';

export const sliderTrackStyles = css.raw({
  position: 'relative',
  width: '100%',
  height: 'Slider.Track.height',
  borderRadius: 'Slider.Track',
  pointerEvents: 'none',
  background: 'Slider.Track.bg.default',
  overflow: 'hidden',
});
